import {Injectable} from '@angular/core';
import {AngularFirestore} from '@angular/fire/compat/firestore';
import {ProductItem} from '../models/product';
import {Ordered} from '../models/ordered';
import {Enrollment} from '../models/enrollment';
import {Observable, forkJoin} from 'rxjs';
import {finalize, map} from 'rxjs/operators';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {AngularFireStorage, AngularFireStorageReference, AngularFireUploadTask} from '@angular/fire/compat/storage';

@Injectable({
  providedIn: 'root'
})
export class Certificate2Service {

  constructor (
    private db: AngularFirestore,
    private fb: FormBuilder,
    private fs: AngularFireStorage,
  ) { }

  getById (eventId: string): Promise<any> {
    return this.db.collection('sbccv_events').doc(eventId).get().toPromise()
      .then((result: any) => {
        return {"id": result.id, ...result.data()};
      });
  }

  getProducts (eventoId: string): Promise<any[]> {
    console.log("event-id: " + eventoId)
    return this.db.collection('sbccv_product_itens', ref => ref
      .where('event_id', '==', eventoId))
      .get()
      .toPromise()
      .then(async (querySnapshot: any) => {
        return querySnapshot.docs.map(doc => doc.data().product_id)
      }
      );
  }

  async getSubscriptions (productIds: string[]) {
    // Cria um array de observables para cada product_id
    const orderObservables = productIds.map(productId =>
      this.db.collection<Ordered>('sbccv_orders', ref => ref
        .where('product_id', '==', productId)
        .where('returnCode', '==', '00')
        .orderBy('date', 'desc')
      ).get().pipe(
        map(snapshot => snapshot.docs.map(doc => doc.data() as Ordered))
      )
    );

    // Combina todos os observables em um único observable que emite um array de arrays
    return forkJoin(orderObservables).pipe(
      map(ordersArrays => ordersArrays.reduce((acc, current) => acc.concat(current), []))
    );

  }

  getProductId (event_id) {
    return this.db.collection<ProductItem>('sbccv_product_itens', ref => ref
      .where('event_id', '==', event_id))
      .get()
  }

  async getSubscriptionsAndEnrollments (event_id, product_id) {

    const subscriptionsPromise = new Promise((resolve) => {

      return this.db.collection<Ordered>('sbccv_orders', ref => ref
        .where('product_id', '==', product_id)
        .where('returnCode', '==', '00')
        .orderBy('date', 'desc'))
        .get()
        .subscribe((subscriptions) => {
          const arraySubscription: any[] = [];
          subscriptions.forEach((subscription) => {
            arraySubscription.push(this.makeSubcription(subscription))
          })

          resolve(arraySubscription)
        })

    })

    const enrollmentsPromise = new Promise((resolve) => {
      return this.db.collection<Enrollment>('sbccv_enrollment', ref => ref
        .where('event_id', '==', event_id)).snapshotChanges()
        .subscribe((enrollments) => {
          const arrayEnrollments: any[] = [];
          enrollments.forEach((enrollment) => {
            arrayEnrollments.push(this.makeEnrollment(enrollment))
          })
          resolve(enrollmentsPromise)
        })
    })

    return (await Promise.all([ subscriptionsPromise, enrollmentsPromise ]));

  }

  makeSubcription (item): any {
    let subcription: any = {}

    subcription.id = item.payload.doc.id;
    subcription.date = item.payload.doc.data().date;
    subcription.product_id = item.payload.doc.data().product_id;
    subcription.product_name = item.payload.doc.data().product_name;
    subcription.topic_name = item.payload.doc.data().topic_name;
    subcription.member_name = item.payload.doc.data().member_name;
    subcription.category_name = item.payload.doc.data().category_name;

    return subcription
  }

  makeEnrollment (item): Enrollment {

    let enrollment = new Enrollment()

    enrollment.id = item.payload.doc.id;
    enrollment.created = new Date()

    enrollment.event_id = item.payload.doc.data().event_id;
    enrollment.event_name = item.payload.doc.data().event_name;

    enrollment.day_id = item.payload.doc.data().day_id;
    enrollment.day_name = item.payload.doc.data().day_name;

    enrollment.activity_id = item.payload.doc.data().activity_id;
    enrollment.activity_name = item.payload.doc.data().activity_name;

    enrollment.topic_id = item.payload.doc.data().topic_id;
    enrollment.topic_name = item.payload.doc.data().topic_name;

    enrollment.finished = item.payload.doc.data().finished;
    enrollment.member_id = item.payload.doc.data().member_id;
    enrollment.member_name = item.payload.doc.data().member_name;
    enrollment.type = item.payload.doc.data().type;

    enrollment.certificate_url = item.payload.doc.data().certificate_url || '';

    return enrollment
  }

  createForm (data: any) {
    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      context_id: new FormControl(''),
      congress: new FormControl(''),

      docUsers: new FormControl(''),
      docUserTop: new FormControl(''),
      docUserLeft: new FormControl(''),

      docStaff: new FormControl(''),
      docStaffTop: new FormControl(''),
      docStaffLeft: new FormControl(''),

      urlQRCodeSubscr: new FormControl(''),
      urlQRCodeStaff: new FormControl(''),

      subscriberQRCode: new FormControl(''),
      staffQRCode: new FormControl(''),

    });

    if (data) {
      form.controls.id.setValue(data.id);
      form.controls.context_id.setValue(data.context_id);
      form.controls.congress.setValue(data.congress);

      form.controls.docUsers.setValue(data.docUsers);
      form.controls.docUserTop.setValue(data.docUserTop);
      form.controls.docUserLeft.setValue(data.docUserLeft);
      form.controls.docStaff.setValue(data.docStaff);

      form.controls.docStaffTop.setValue(data.docStaffTop);
      form.controls.docStaffLeft.setValue(data.docStaffLeft);

      form.controls.urlQRCodeSubscr.setValue(data.urlQRCodeUser);
      form.controls.urlQRCodeStaff.setValue(data.urlQRCodeStaff);

    }
    return form
  }

  /*
  createCertificateSubscriptionsForm (data: any) {
    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      event_id: new FormControl(''),
      imageSubscriptions: new FormControl(''),
      qrCodeSubscriptions: new FormControl(''),
    });

    if (data) {
      form.controls.id.setValue(data.id);
      form.controls.event_id.setValue(data.event_id);
      form.controls.imageSubscriptions.setValue(data.imageSubscriptions);
      form.controls.qrCodeSubscriptions.setValue(data.qrCodeSubscriptions);
    }
    return form
  }
  */

  /*
  createCertificateSpeakersForm (data: any) {
    let form: FormGroup = this.fb.group({
      id: new FormControl(''),
      event_id: new FormControl(''),
      imageSpeakers: new FormControl(''),
      qrCodeSpeakers: new FormControl(''),
    });

    if (data) {
      form.controls.id.setValue(data.id);
      form.controls.event_id.setValue(data.event_id);
      form.controls.imageSpeakers.setValue(data.imageSpeakers);
      form.controls.qrCodeSpeakers.setValue(data.qrCodeSpeakers);
    }
    return form
  }
  */

  async getConfig (id: any) {
    const result: any = await this.db.collection('sbccv_certificate_configs')
      .doc(id)
      .get()
      .toPromise();

    if (result.exists) {
      return {
        "id": result.id,
        "event_id": result.id,
        "event_name": result.data().name,
        "isCongress": result.data().isCongress,
        "staff_image_url": result.data().staff_image_url,
        "staff_qrCode": result.data().staff_qrCode,
        "staff_role": result.data().staff_role,
        "user_image_url": result.data().user_image_url,
        "user_qrCode": result.data().user_qrCode,
        "user_role": result.data().user_role,
      };
    } else {
      return null;
    }

  }

  async updateConfig (entity: any) {
    return this.db.collection('sbccv_certificate_configs')
      .doc(entity.id)
      .set(Object.assign({}, entity), {merge: true});
  }

  async uploadImage (file: any, entity_id: any, prefix: any) {
    const fsRef: AngularFireStorageReference = this.fs.ref("certificate_configs/" + prefix + entity_id + ".png");
    const fsTask: AngularFireUploadTask = fsRef.put(file);

    fsTask.snapshotChanges().pipe(
      finalize(async () => {
        fsRef.getDownloadURL().subscribe(async (url: any) => {

          try {
            
            let dataToUpdate: any = {}
            if (prefix === "staff_") {
              dataToUpdate = {staff_image_url: url}
            } else {
              dataToUpdate = {user_image_url: url}
            }

            await this.db.collection('sbccv_certificate_configs').doc(entity_id).set(dataToUpdate, {merge: true});
            return "ok";

          } catch (err) {
            console.log("erro upadate image: " + JSON.stringify(err));
          }

        });
      }))
      .subscribe();
  }

}
